var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1622_22705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.5C6.65 1.5 2 6.15 2 12C2 17.85 6.65 22.5 12.5 22.5C18.35 22.5 23 17.85 23 12C23 6.15 18.35 1.5 12.5 1.5ZM16.55 17.25L12.5 13.2L8.45 17.25L7.25 16.05L11.3 12L7.25 7.95L8.45 6.75L12.5 10.8L16.55 6.75L17.75 7.95L13.7 12L17.75 16.05L16.55 17.25Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1622_22705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconFilled);
export default __webpack_public_path__ + "static/media/close-icon-filled.1453b5e1a38d997bcd4b530e413f3e9b.svg";
export { ForwardRef as ReactComponent };